import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="border border-border p-12 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto text-muted-foreground" size={40} />
        <h1 className="font-display font-bold text-2xl mt-6">Checkout canceled.</h1>
        <p className="text-sm text-muted-foreground mt-2">Your cart is saved — pick up where you left off anytime.</p>
        <Link to="/shop" data-testid="back-to-store-link" className="inline-block mt-8 bg-foreground text-white px-6 py-3 text-sm uppercase tracking-wider hover:bg-primary transition-colors">
          Back to Store
        </Link>
      </div>
    </div>
  );
}
